import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { 
    clearAmanFormData, 
    selectAmanForm, 
    setAmanFormData 
} from "../redux/features/amanFormSlice";

const useAmanFormData = (formName, setFormData) => {
    const dispatch = useDispatch();
    const amanFormData = useSelector(selectAmanForm);
    const redux_form_data = amanFormData?.[formName];

    useEffect(() => {
        if (redux_form_data && setFormData) {
            setFormData(redux_form_data);
        }
    }, []);

    const saveAmanDataInRedux = async (formData) => {
        return new Promise((resolve, reject) => {
            try {
                dispatch(setAmanFormData({ form_name: formName, data: formData }));
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    };

    const removeAmanFormData = () => {
        dispatch(clearAmanFormData({ form_name: formName }));
    };

    return { 
        saveAmanDataInRedux, 
        removeAmanFormData, 
        redux_form_data 
    };
};

export default useAmanFormData;
